import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import LanguageProvider from './containers/LanguageProvider';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import 'typeface-roboto'

import './index.css';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Roboto',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#1890ff',
    },
    white: {
      main: '#fff',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </ThemeProvider>,
  document.getElementById('root')
);